import { requestJson } from './http';
import { normalizeReservation, normalizeReservations } from '../utils/reservationAdapter';

export function getReservations(params = {}) {
  const query = new URLSearchParams(params);
  const qs = query.toString();
  return requestJson(`/api/records${qs ? `?${qs}` : ''}`).then(data => ({
    ...data,
    rawRecords: data.records || [],
    records: normalizeReservations(data.records || [])
  }));
}

export function getReservation(recordId) {
  return requestJson(`/api/records/${encodeURIComponent(recordId)}`).then(data => ({
    ...data,
    rawRecord: data.record || null,
    record: data.record ? normalizeReservation(data.record) : null
  }));
}

export function createReservation(fields) {
  return requestJson('/api/records', {
    method: 'POST',
    headers: { 'x-idempotency-key': crypto.randomUUID() },
    body: JSON.stringify({ record: { fields } })
  }).then(data => {
    const rawRecord = data.records?.[0] || data.record || null;
    return {
      ...data,
      rawRecord,
      record: rawRecord ? normalizeReservation(rawRecord) : null
    };
  });
}

export function updateReservation(recordId, fields) {
  return requestJson(`/api/records/${encodeURIComponent(recordId)}`, {
    method: 'PATCH',
    headers: { 'x-idempotency-key': crypto.randomUUID() },
    body: JSON.stringify({ record: { fields } })
  }).then(data => {
    const rawRecord = data.records?.[0] || data.record || null;
    return {
      ...data,
      rawRecord,
      record: rawRecord ? normalizeReservation(rawRecord) : null
    };
  });
}

export function getActualPaxEntries(recordId) {
  return requestJson(`/api/records/${encodeURIComponent(recordId)}/actual-pax-entries`);
}

export function addActualPaxEntry(recordId, payload) {
  return requestJson(`/api/records/${encodeURIComponent(recordId)}/add-pax`, {
    method: 'POST',
    headers: { 'x-idempotency-key': payload.requestKey || crypto.randomUUID() },
    body: JSON.stringify(payload)
  });
}
